(() => {
  function initEventDialogs(scope = document) {
    scope.querySelectorAll('[data-event-dialog-open]').forEach((trigger) => {
      if (trigger.dataset.eventDialogReady === 'true') return;
      trigger.dataset.eventDialogReady = 'true';

      const dialogId = trigger.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog) return;

      trigger.addEventListener('click', () => {
        if (typeof dialog.showModal !== 'function') {
          const fallback = trigger.dataset.eventFallbackUrl;
          if (fallback) window.location.href = fallback;
          return;
        }
        dialog.dataset.returnFocusId = trigger.id || '';
        dialog.showModal();
        const closeButton = dialog.querySelector('[data-event-dialog-close]');
        requestAnimationFrame(() => closeButton?.focus());
      });

      dialog.querySelectorAll('[data-event-dialog-close]').forEach((button) => {
        button.addEventListener('click', () => dialog.close());
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', () => {
        const returnFocusId = dialog.dataset.returnFocusId;
        if (!returnFocusId) return;
        const returnFocus = document.getElementById(returnFocusId);
        returnFocus?.focus();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initEventDialogs());
  } else {
    initEventDialogs();
  }

  document.addEventListener('shopify:section:load', (event) => initEventDialogs(event.target));
})();
